<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Log de Notas fiscais'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Inicial</label>
                      <datepicker ref="programaticOpen3" v-model="dataSearch.init" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="input-group input-with-date">
                      <label>Data Final</label>
                      <datepicker ref="programaticOpen4" v-model="dataSearch.end" :language="ptBR"
                                  :format="customFormatter"/>
                      <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Status</label>
                      <select v-model="dataSearch.name">
                        <option value="">Todos</option>
                        <option value="true">Sucesso</option>
                        <option value="false">Falha</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="companyId">ID da empresa</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="companyId"
                             name="companyId">
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Razão Social</label>
                      <input v-model="dataSearch.razaoSocial" type="text" class="form-control" name="razaoSocial"
                             required>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataLog !== '' && !dataLog.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataLog.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de logs ({{ dataLog.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> Razão Social</th>
                        <th> CPF/CNPJ</th>
                        <th> Valor da nota</th>
                        <th> Resultado</th>
                        <th> Json</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataLog">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId.id + '/' + c.contextCode"
                               target="_blank" class="link">{{ c.representationName }}</a></td>
                        <td>{{ c.cnpj }}</td>
                        <td>R{{ c.price | currency }}</td>
                        <td>{{ c.Result }}</td>
                        <td>{{ c.json }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import swal from 'sweetalert';
import moment from 'moment'

import {
  GET_INVOICES_LOG_REPORT_BY_ID
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "log-de-notas-fiscais",
  components: {
    datepicker,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      callCheckRequest: '',
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      dataLog: '',
      dataSearch: {
        init: new Date(moment().subtract(5, 'days')),
        end: new Date(moment().subtract(0, 'days')),
        name: '',
        companyId: '',
        razaoSocial: ''
      },
    }
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getList() {
      if (this.dataSearch.init && this.dataSearch.end) {
        moment.locale('pt-br');

        this.loadingList = true;
        let url = GET_INVOICES_LOG_REPORT_BY_ID;
        url += "?init=" + moment(this.dataSearch.init).format("YYYY-MM-DD");
        url += "&end=" + moment(this.dataSearch.end).format("YYYY-MM-DD");

        if (this.dataSearch.name !== '') {
          url += "&success=" + this.dataSearch.name;
        } else {
          url += "&success=null";
        }

        if (this.dataSearch.companyId)
          url += "&companyId=" + this.dataSearch.companyId;

        if (this.dataSearch.razaoSocial)
          url += "&name=" + this.dataSearch.razaoSocial;

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
          UTIL_SERVICE.console("RESULT GET_INVOICES_LOG_REPORT_BY_ID:", response.data);

          if (response.data.length)
            this.dataLog = response.data;
          else
            this.dataLog = [];

          this.loadingList = false;
          this.failRequest = false;
        }).catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      } else {
        swal("Aviso", "Preencha as datas para pesquisar", "error");
      }
    }
  }
}
</script>

<style lang="scss">
.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/LogInvoices.vue